export default (state = {}, {currentPeriodId}: any) => {
  return {
    ...state,
    currentPeriodId,
  };
};
